module.exports = __webpack_public_path__ + "media/images/landing/cyber/privacy-security-9d3aae503c64277e7b6fd54e462861d4.png";